import * as React from 'react';
import classNames from 'classnames';
import { ThemeContext } from 'app-themes';

import AntSelect, {
	SelectProps as AntSelectProps,
	OptionProps,
	OptGroupProps,
	SelectValue,
} from 'antd/lib/select';

import styles from './Select.module.scss';
export interface SelectProps extends AntSelectProps {}

export interface SelectState {
	open: boolean;
}

export class Select extends React.Component<SelectProps, SelectState> {
	inputRef: any = React.createRef<AntSelect>();
	static Option: React.ClassicComponentClass<OptionProps>;
	static OptGroup: React.ClassicComponentClass<OptGroupProps>;
	static contextType = ThemeContext;
	justFocused: boolean = false;

	state = {
		open: false,
	};

	onFocus = () => {
		this.setState({
			open: true,
		});
		this.justFocused = true;
		const { current } = this.inputRef;
		if (current && current.rcSelect && current.rcSelect.inputRef) {
			// in case of 'showSearch' in Select we should focus inner input
			current.rcSelect.inputRef.focus();
		}
	};

	onBlur = () => {
		this.setState({
			open: false,
		});
		this.justFocused = false;
		const { current } = this.inputRef;
		if (current && current.rcSelect && current.rcSelect.inputRef) {
			// in case of 'showSearch' in Select we should blur inner input
			current.rcSelect.inputRef.blur();
		}
	};

	onSelect = (val: SelectValue, option: React.ReactElement<any>) => {
		this.setState({
			open: false,
		});
		this.justFocused = false;
		if (this.props.onSelect) {
			this.props.onSelect(val, option);
		}
	};

	onInputKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
		if (e.keyCode === 27) {
			// Esc
			this.setState({
				open: false,
			});
		}
		if (e.keyCode === 13 && !this.state.open) {
			// Enter
			this.setState({
				open: true,
			});
		}
		if (e.keyCode === 9 && this.state.open) {
			// Tab
			this.setState({
				open: false,
			});
		}
	};

	onDropdownVisibleChange = (open: boolean) => {
		if (open && !this.state.open) {
			// onMouse click or press Enter we should manually open it
			this.setState({
				open: true,
			});
		}
		// this.justFocused - to avoid incorrect behaviour when click by mouse on not focused select
		if (!open && this.state.open && !this.justFocused) {
			// on press Esc we should manually close it
			this.setState({
				open: false,
			});
		}
		this.justFocused = false;
	};

	render() {
		const { dropdownClassName, ...restProps } = this.props;
		const theme = this.context;
		return (
			<AntSelect
				className={classNames(styles.select, {
					[styles[`select-${theme}`]]: theme !== '',
				})}
				dropdownClassName={classNames(styles.selectDropdown, dropdownClassName)}
				ref={this.inputRef}
				{...restProps}
				onSelect={this.onSelect}
				onFocus={this.onFocus}
				onBlur={this.onBlur}
				onInputKeyDown={this.onInputKeyDown}
				open={this.state.open}
				onDropdownVisibleChange={this.onDropdownVisibleChange}
			/>
		);
	}
}

Select.Option = AntSelect.Option;
Select.OptGroup = AntSelect.OptGroup;

export default Select;
